import { Spin, Table } from "antd";
import React from "react";
import NoCasesTable from "../NoCasesTable";
import styles from "../TableData.module.css";

const ReopenedCaseTable = ({
    loading,
    cases,
    columns,
    handleRowClick,
    filterTableData,
    pageNumber,
    setPageNumber,
}) => {
    return (
        <div>
            {loading ? (
                <Spin />
            ) : cases.length == 0 ? (
                <NoCasesTable />
            ) : (
                <Table
                    pagination={{
                        showSizeChanger: false,
                        pageSize: 10,
                        current: pageNumber,
                        onChange: (page) => setPageNumber(page),
                    }}
                    scroll={{ y: 400 }}
                    columns={columns}
                    dataSource={
                        filterTableData.length > 0 ? filterTableData : cases
                    }
                    size="middle"
                    rowKey="CaseNumber"
                    className={styles.tableContainer}
                    onRow={(record) => ({
                        onClick: () => handleRowClick(record.id),
                    })}
                    bordered
                />
            )}
        </div>
    );
};

export default ReopenedCaseTable;
